module.exports = __webpack_public_path__ + "img/img_03.f840e9a9.png";